import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CheckCircle, ArrowRight, Home, FileText } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { formatCurrency } from '../lib/utils';

export default function QuoteSuccess() {
  const [searchParams] = useSearchParams();
  const quoteId = searchParams.get('id');
  const total = searchParams.get('total');

  return (
    <div className="min-h-screen pt-24 pb-16 flex items-center" data-testid="quote-success-page">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          className="max-w-lg mx-auto"
        >
          <Card className="bg-card border-border/50">
            <CardContent className="p-8 text-center">
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.2, type: 'spring' }}
                className="w-20 h-20 mx-auto mb-6 rounded-full bg-green-500/20 flex items-center justify-center"
              >
                <CheckCircle className="w-10 h-10 text-green-500" />
              </motion.div>

              <h1 className="text-2xl font-heading font-bold text-white mb-2">
                Quote Request Submitted!
              </h1>
              
              <p className="text-muted-foreground mb-6">
                Thank you for your interest in IQES. Our team will review your request and contact you within 24 hours.
              </p>

              {quoteId && (
                <div className="p-4 rounded-xl bg-muted/30 border border-border/50 mb-6">
                  <div className="text-sm text-muted-foreground mb-1">Quote Reference</div>
                  <div className="font-mono text-primary">{quoteId}</div>
                  {total && (
                    <>
                      <div className="text-sm text-muted-foreground mt-3 mb-1">Estimated Total</div>
                      <div className="text-2xl font-heading font-bold text-white">
                        {formatCurrency(parseFloat(total))}+
                      </div>
                    </>
                  )}
                </div>
              )}

              <div className="flex flex-col gap-3">
                <Link to="/" data-testid="success-home-btn">
                  <Button className="w-full rounded-full bg-primary hover:bg-primary/90">
                    <Home className="mr-2 w-4 h-4" />
                    Back to Home
                  </Button>
                </Link>
                <Link to="/services" data-testid="success-services-btn">
                  <Button variant="outline" className="w-full rounded-full border-border/50">
                    <FileText className="mr-2 w-4 h-4" />
                    View Our Services
                  </Button>
                </Link>
              </div>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </div>
  );
}
